import { render, staticRenderFns } from "./IntegrationIconTableCell.vue?vue&type=template&id=04965cd5&scoped=true"
import script from "./IntegrationIconTableCell.vue?vue&type=script&lang=js"
export * from "./IntegrationIconTableCell.vue?vue&type=script&lang=js"
import style0 from "./IntegrationIconTableCell.vue?vue&type=style&index=0&id=04965cd5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04965cd5",
  null
  
)

export default component.exports